import { render, staticRenderFns } from "./RD14.vue?vue&type=template&id=2d5227e1&scoped=true"
import script from "./RD14.vue?vue&type=script&lang=js"
export * from "./RD14.vue?vue&type=script&lang=js"
import style0 from "./RD14.vue?vue&type=style&index=0&id=2d5227e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5227e1",
  null
  
)

export default component.exports